export const TOGGLE_ACCEPT_MODAL_INVITATION = 'TOGGLE_ACCEPT_MODAL_INVITATION';
export const TOGGLE_SEND_MODAL_INVITATION = 'TOGGLE_SEND_MODAL_INVITATION';
export const TOGGLE_EDIT_MODAL_INVITATION = 'TOGGLE_EDIT_MODAL_INVITATION';
